import { render, staticRenderFns } from "./aluno-turma.vue?vue&type=template&id=e0330706&"
import script from "./aluno-turma.vue?vue&type=script&lang=js&"
export * from "./aluno-turma.vue?vue&type=script&lang=js&"
import style0 from "./aluno-turma.vue?vue&type=style&index=0&id=e0330706&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports